import { Box, Grid, Card, makeStyles, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import HomeSearch from './HomeSearch';
import AlternateHomeSearch from './AlternateHomeSearch';
import useAuth from '../../../hooks/useAuth';
import ConciergeServiceCard from './ConciergeServiceCard';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { minHeight } from '@material-ui/system';


const useStyles = makeStyles((theme) => ({
  searchContainer: {
    [theme.breakpoints.up('xs')]: {
      paddingLeft: '20vw',
      paddingRight: '20vw'
    },
  },
  video: {
    position: 'absolute',
    width: '100%',
    left: '50%',
    top: '50%',
    height: '100%',
    objectFit: 'cover',
    transform: 'translate(-50%, -50%)',
    zIndex: -1,
  },
  fullImage: {
    position: 'absolute',
    width: '100%',
    left: '50%',
    top: '50%',
    height: '100%',
    objectFit: 'cover',
    transform: 'translate(-50%, -50%)',
    zIndex: -1,
  },
  halfImage: {
    position: 'absolute',
    width: '100%',
    left: '50%',
    top: theme.name != "AudacyFlash" && theme.name != "CreativeLove" ? '25%' : '50%',
    height: theme.name == "CCC" ? '50%' : '100%',
    objectFit: 'cover',
    transform: 'translate(-50%, -50%)',
    zIndex: -1,
  },
  gridItem: {
    display: 'flex',
  }
}))

const FrontendHero = (props) => {
  const { categories, services } = props
  const theme = useTheme();
  const classes = useStyles()
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleToggleModal = () => setIsModalOpen(!isModalOpen);

  // detect if this is a mobile device
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const serviceTitlesToFilter = ["full production", "dry voice only", "get a campaign", "jingle", "ai production"];
  const imageUrls = [
    '/static/fullproduction.png',
    '/static/dryvoiceonly.png',
    '/static/getcampaign.png',
    '/static/jingle.png',
    '/static/aiproduction.png',
  ];
  // console.log('services before filtering', services)
  if (theme.name === "CCC" && !services.some(service => service.title.toLowerCase() === "ai production")) {
    services.push({
      id: 13,
      title: 'AI Production',
      description: 'Create a SPEC spot in minutes. AI scripts. AI voice overs. Exclusive Music Imaging.',
    });
  }
  const filteredServices = services
    .filter((service) =>
      serviceTitlesToFilter.some((titleToFilter) =>
        service.title.toLowerCase() === titleToFilter.toLowerCase()
      )
    )
    .map((service, index) => ({
      ...service,
      imageUrl: imageUrls[index],
    }));
  // console.log('filteredServices', filteredServices)

  const showCCCConciergeCards = () => {
    return (
      <Grid container direction="row" justifyContent="space-evenly" alignItems="top" alignContent="center" spacing={2} sx={{}}>
        {filteredServices.map((service) => (
          <Grid key={service.id} item lg={4} md={4} sm={12} xs={12} sx={{ maxWidth: '280px !important' }}>
            <ConciergeServiceCard
              label={service.title}
              description={service.description}
              image={service.imageUrl}
              onClick={() => {
                if (service.title.toLowerCase() === "get a campaign") {
                  handleToggleModal();
                } else if (service.title.toLowerCase() === "ai production") {
                  window.location.replace('http://cumulus.radiospecai.com/')
                } else {
                  navigate(`/concierge/${service.id}`);
                }
              }}
            />
          </Grid>
        ))}
      </Grid>
    )
  }


  return <Box sx={{ display: 'flex', height: '100%', flexDirection: 'column', justifyContent: theme.name != "CCC" ? 'center' : 'start' }}>
    {
      theme.heroVid && !isMobile
        ? <video autoPlay muted loop className={classes.video}><source src={theme.heroVid} type="video/mp4" /></video>
        : theme.name != "CCC"  ? <img src={theme.heroImg} className={classes.fullImage} /> :
          <Box sx={{ display: 'flex', justifyContent: 'center', height: isAuthenticated ? '50%' : '100%', backgroundImage: `url(${theme.heroImg})`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
            {isAuthenticated &&
              <Box className={classes.searchContainer} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', pb: '16px' }}>
                <HomeSearch categories={categories} />
              </Box>
            }
          </Box>
    }
    {theme.name != 'CCC' &&
      <Box sx={{ display: 'flex' }}>
        <Grid container>
          {isAuthenticated && theme.name != "AudacyFlash" && theme.name != "CreativeLove"
            ? <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box className={classes.searchContainer} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <HomeSearch categories={categories} />
              </Box>
            </Grid>
            : <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box className={classes.searchContainer} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', ml: '3rem' }}>
                {/* <Box className={classes.searchContainer} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', ml: '3rem', mt: '4rem' }}> */}
                <AlternateHomeSearch />
              </Box>
            </Grid>
          }
        </Grid>
      </Box>
    }
    {theme.name === "CCC" &&
      <Box sx={{ px: 20, margin: 'auto 0' }}>
        {isAuthenticated && showCCCConciergeCards()}
      </Box>
    }
    {isModalOpen && (
      <Dialog open={isModalOpen} onClose={handleToggleModal}>
        <DialogTitle>
          Choose a Campaign Type:
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', alignItems: 'center', margin: 'auto' }}>
            <Button
              variant="contained"
              sx={{ backgroundColor: theme.palette.primary.main, px: 6, py: 1, ml: 2, mr: 2 }}
              onClick={() => navigate('/concierge/10')}
            >
              Audio
            </Button>
            <Button
              variant="contained"
              sx={{ backgroundColor: theme.palette.primary.main, px: 6, py: 1, ml: 2, mr: 2 }}
              onClick={() => navigate('/concierge/11')}
            >
              Digital
            </Button>
            {/* <Button
              variant="contained"
              sx={{ backgroundColor: theme.palette.primary.main, px: 6, py: 1, ml: 2, mr: 2 }}
              onClick={() => navigate('/concierge/12')}
            >
              Jingle
            </Button> */}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleToggleModal}>Close</Button>
        </DialogActions>
      </Dialog>
    )}
  </Box>
};

export default FrontendHero;
